import { type ApolloError, useQuery } from '@apollo/react-hooks';
import {
  type ApolloClient,
  type NormalizedCacheObject,
  gql,
} from '@apollo/client';
import type { Delegation } from '../../../components';
import dayjs from 'dayjs';

//  hook
type GetDelegator = {
  delegator: Delegation[];
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};

export const useGetDelegator = (netId: string): GetDelegator => {
  const { data, loading, error, refetch } = useQuery(
    gql`
      query ($netId: String!) {
        getDelegatedRights(netId: $netId) {
          netId
          delegatedRights {
            netId
            displayName
            department
            email
            role
            createdAt
          }
        }
      }
    `,
    {
      variables: { netId },
      skip: !netId,
      fetchPolicy: 'network-only',
    },
  );
  const delegator = (data?.getDelegatedRights?.delegatedRights ?? []).map(
    (element: any) => {
      return {
        name: element?.displayName ?? '',
        netId: element?.netId ?? '',
        email: element?.email ?? '',
        department: element?.department ?? '',
        startDate: dayjs(element?.createdAt).format('DD/MM/YYYY') ?? '',
      };
    },
  );

  return { delegator, loading, error, refetch };
};

// async func
export const useGetDelegatorAsync = async (
  client: ApolloClient<NormalizedCacheObject>,
  netId: string,
): Promise<any> => {
  const { data } = await client.query({
    query: gql`
      query ($netId: String!) {
        getDelegatedRights(netId: $netId) {
          delegatedRights {
            netId
            displayName
            department
            role
          }
        }
      }
    `,
    variables: { netId },
    fetchPolicy: 'network-only',
  });

  return data.advancedUser;
};
